import {configureStore, ThunkAction, Action} from '@reduxjs/toolkit';
import authReducer from '../components/auth/authSlice';
import {USER} from '../components/auth/auth.type';
import configReducer from '../components/layout/configSlice';
import localStorageUtils from '../utils/localStoraegUtils';
import setupEmployeesReducer from '../components/setup/employee/employees/employeeSlice';
import setupRolesReducer from '../components/setup/employee/roles/rolesSlice';
import stationsReducer from '../components/setup/station/stations/stationsSlice';
import racksReducer from '../components/setup/rack/racks/racksSlice';
import stationGroupsSlice from '../components/setup/station/stationGroups/stationGroupsSlice';
import stationGroupEmployeesSlice from '../components/setup/station/stationGroups/stationGroupEmployees/stationGroupEmployeesSlice';
import batteryCategorySlice from '../components/setup/battery/batteryCategory/batteryCategorySlice';
import chargerCategorySlice from '../components/setup/charger/chargerCategory/chargerCategorySlice';
import rackCategorySlice from '../components/setup/rack/rackCategory/rackCategorySlice';
import chargersSlice from '../components/setup/charger/chargers/chargersSlice';
import batteriesSlice from '../components/setup/battery/batteries/batteriesSlice';
import liveBatteriesSlice from '../components/liveBatteries/liveBatteriesSlice';
import rackScreenSlice from '../components/stationRackScreen/rackScreenSlice';
import swapSlice from '../components/Swap/swapSlice';
import customersSlice from '../components/customers/customersSlice';
import notifications from '../components/notifications/notificationsSlice';
import vehicleSlice from '../components/setup/Vehicle/vehicleSlice';
import organisationConfigSlice from '../components/organisationConfig/organisationConfigSlice';

const load = () => {
  const state = {
    auth: {
      isLoading: false,
      user: {
        details: {
          email: '',
          id: null,
          name: '',
          organisationId: '',
          username: '',
        },
        token: null,
      } as USER,
    },
  };

  const user = localStorageUtils.getUser();
  if (user === null) {
    return state;
  }
  state.auth.user = user;
  return state;
};

export const store = configureStore({
  reducer: {
    auth: authReducer,
    config: configReducer,
    liveBatteries: liveBatteriesSlice,
    rackScreen: rackScreenSlice,
    employees: setupEmployeesReducer,
    roles: setupRolesReducer,
    stations: stationsReducer,
    stationGroupEmployees: stationGroupEmployeesSlice,
    stationGroups: stationGroupsSlice,
    batteryCategory: batteryCategorySlice,
    chargerCategory: chargerCategorySlice,
    batteries: batteriesSlice,
    chargers: chargersSlice,
    rackCategory: rackCategorySlice,
    racks: racksReducer,
    swap: swapSlice,
    customers: customersSlice,
    notifications: notifications,
    vehicles: vehicleSlice,
    organisationConfig: organisationConfigSlice,
  },
  preloadedState: load(),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
